<template>
    <main class="custom-Wrapper-main PageNotFound Wrapper-main Wrapper-centered">
        <div class="PageNotFound-main Main Main-container">
            <section>
                <h1 class="custom-h1">404 Error!</h1>
                <h2 class="custom-h2">¯\_(ツ)_/¯</h2>
            </section>
        </div>
    </main>
</template>

<script>
    export default {
        name: 'PageNotFound'
    };
</script>
